import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CityService } from '../../services/city.service';
import { CSEService } from '../../services/cse.service';
import { ERPService } from '../../services/erp.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import {
    Carrier
    , City
    , MacropointLocationProvider
    , SearchCarrier
    , SearchCarrierRMISCertification
} from '../../models/models';

@Component({
    selector: 'carrier-form',
    templateUrl: './carrier-form.component.html',
    standalone: false
})
export class CarrierForm implements OnInit, OnChanges {
    @Input() carrierID: number = 0;
    @Output() carrierSaved: EventEmitter<Carrier> = new EventEmitter<Carrier>();

    public carrier: Carrier = {} as Carrier;
    public searchCarrier: SearchCarrier = {} as SearchCarrier;
    public searchCarrierRMIS: SearchCarrierRMISCertification = {} as SearchCarrierRMISCertification;
    private carrierCity: City = {} as City;
    public defaultCarrierCity: string = "";
    public macropointLocationProviders: MacropointLocationProvider[] = [];
    public submitted: boolean = false;
    public phoneMask: string = "(999) 000-0000";
    public isLoading: boolean = false;

    private usPhoneMask: string = '(999) 000-0000';
    private mexicoPhoneMask: string = '99999-999-999-9999';

    public formGroup: UntypedFormGroup = new UntypedFormGroup({
        cityCtrl: new UntypedFormControl('')
    });

    constructor(private cityService: CityService, private cseService: CSEService,
        private erpService: ERPService, private notificationService: NotificationService,
        private orderService: OrderService, private router: Router) {
    }

    ngOnInit() {
        this.getMacropointLocationProviders();
    }

    ngOnChanges() {
        this.getCarrier();
        this.getSearchCarrier();
        this.getSearchCarrierRMIS();
    }

    private getMacropointLocationProviders() {
        this.orderService.getMacropointLocationProviders().subscribe(result => {
            this.macropointLocationProviders = result;
        });
    }

    private getCarrier() {
        this.isLoading = true;
        this.cseService.getCarrierByID(this.carrierID).subscribe(result => {
            this.isLoading = false;
            this.carrier = result.resultCollection[0];
            this.cityService.getCityByID(this.carrier.cityID).subscribe(result2 => {
                var city = result2.resultCollection[0];
                this.defaultCarrierCity = city.cityST;
            });
        });
    }

    private getSearchCarrier() {
        this.isLoading = true;
        this.cseService.getSearchCarrierByCarrierID(this.carrierID).subscribe(result => {
            this.isLoading = false;
            this.searchCarrier = result.resultCollection[0];
        });
    }

    private getSearchCarrierRMIS() {
        this.isLoading = true;
        this.cseService.getSearchCarrierRMISCertificationByCarrierID(this.carrierID).subscribe(result => {
            this.isLoading = false;
            this.searchCarrierRMIS = result.resultCollection[0];
            if (this.searchCarrierRMIS.attachedDate) {
                this.searchCarrierRMIS.attachedDate = new Date(this.searchCarrierRMIS.attachedDate);
            }
            if (this.searchCarrierRMIS.detachedDate) {
                this.searchCarrierRMIS.detachedDate = new Date(this.searchCarrierRMIS.detachedDate);
            }
        });
    }

    public rmisAttachOrDetachCarrier(attachOrDetach: string) {
        this.isLoading = true;
        this.cseService.rmisAttachOrDetachCarrier(this.carrierID, attachOrDetach).subscribe(result => {
            this.isLoading = false;
            this.searchCarrierRMIS = result.resultCollection[0];
            if (this.searchCarrierRMIS.attachedDate) {
                this.searchCarrierRMIS.attachedDate = new Date(this.searchCarrierRMIS.attachedDate);
            }
            if (this.searchCarrierRMIS.detachedDate) {
                this.searchCarrierRMIS.detachedDate = new Date(this.searchCarrierRMIS.detachedDate);
            }
            this.carrierSaved.emit(this.carrier);
        });
    }

    public citySTChanged(evt: any) {
        var cityID = evt;
        this.cityService.getCityByID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.carrierCity = result.resultCollection[0];
                this.carrier.cityID = cityID;
                console.log("cityZipChanged:carrierCity", cityID, this.carrierCity, result);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    public saveCarrier(isERPSync: boolean) {
        var employeeId = parseInt(localStorage.getItem('EmployeeId')!);

        if (this.carrier.carrierID < 1) {
            this.carrier.createdByEmployeeID = employeeId;
        }

        this.isLoading = true;
        this.cseService.saveCarrier(this.carrier, this.carrierCity.zip).subscribe(result => {
            this.isLoading = false;
            var savedCarrier = result;

            if (savedCarrier.carrierID > 0) {
                this.isLoading = false;
                this.notificationService.showSuccess("Successfully saved carrier: " + savedCarrier.carrierCode, "SUCCESS: Save Carrier");
                this.carrierSaved.emit(this.carrier);
           } else {
                this.notificationService.showError("Error saving carrier", "ERROR: Save Carrier");
            }
        });
    }

    public isValid() {
        var ret: boolean = true;
        if (this.carrier.name == null || this.carrier.name == "") {
            ret = false;
        }
        if (this.carrier.mcNumber == null || this.carrier.mcNumber == "") {
            ret = false;
        }
        if (this.carrier.address1 == null || this.carrier.address1 == "") {
            ret = false;
        }
        if (this.carrier.cityID == null || this.carrier.cityID == 0) {
            ret = false;
        }
        return ret;
    }
}
